import React, { useEffect } from "react";
import {
  Box,
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { State } from "../../../../redux/slices";
import moment from "moment";
import { useTranslation } from "react-i18next";

import {
  GroupInfoData,
  OrgGroupTypeIds,
} from "../../../../redux/actions/users/userTypes";

import {
  resetDecipherPassword,
  setEditingUser,
  setSelectedUser,
  setShowPassword,
  setUserValuesToEdit,
  initialState,
} from "../../../../redux/slices/userGroups/userGroupsSliceMultipleTables";

import { ThunkDispatch } from "@reduxjs/toolkit";
import { getUserRoleFromGroups } from "../../../../utils/auto-grouping";

import { SelectChangeEvent } from "@mui/material/Select";

import {
  getUserPassword,
  userUpdateValues,
} from "../../../../redux/actions/users/userAsyncActions";

import { selectLocale } from "../../../../redux/slices/layout";

import {
  focusedLicense,
  selectAvailLicenses,
  selectModalLicense,
} from "../../../../redux/slices/licenses/licenseList";

import {
  ExtendedLicense,
  LicenseStatus,
  PackStatus,
} from "../../../../redux/actions/licenses/licenceTypes";
import {
  bindLicenseUser,
  unlinkLicenseUser,
} from "../../../../redux/actions/licenses/licenseListAsyncActions";
import { userProfiles } from "../../../../redux/actions/users/managerAsyncActions/managerAsyncActions";
import UserActualInformation from "./userActualnformation";
import UserUpdateInformation from "./userInformationToUpdate";

export const style = {
  position: "absolute",
  top: "30%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  maxWidth: "calc(100% - 20px)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

export const style2 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  maxWidth: "calc(100% - 20px)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const SetActions = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  return {
    selectUser: () => {
      dispatch(setSelectedUser(null));
      dispatch(setEditingUser(false));
      dispatch(setUserValuesToEdit(initialState.userValuesUpdate));
    },
    setIsEditingUser: (userEditValues: any) => {
      dispatch(setEditingUser(true));
      dispatch(setUserValuesToEdit(userEditValues));
    },

    setUserEditValues: (values: any) => {
      dispatch(setUserValuesToEdit(values));
    },

    updateUser: (token: string, userId: string) => {
      dispatch(userUpdateValues({ token, userId }));
    },

    fetchRoles: (token: string) => {
      dispatch(userProfiles(token));
    },
    resetPassword: () => {
      dispatch(resetDecipherPassword());
    },
    setShowPassword: (value: boolean) => {
      dispatch(setShowPassword(value));
    },
    getPassword: (token: string, userId: string) => {
      dispatch(getUserPassword({ token, userId }));
    },
    unlinkLicenseUser: (id: string) => {
      dispatch(unlinkLicenseUser(id));
    },
  };
};

export const DetailUserView = () => {
  const [t] = useTranslation("global");
  const dispatch = useDispatch();

  const {
    selectUser,
    setIsEditingUser,
    setUserEditValues,
    updateUser,
    fetchRoles,
    resetPassword,
    setShowPassword,
    getPassword,
    unlinkLicenseUser,
  } = SetActions();
  const {
    selectedUser,
    isEditingUser,
    userValuesUpdate,
    isUpdateLoading,
    isUpdateError,
    loadingUserPassword,
    decipherPassword,
    showPassword,
  } = useSelector((state: State) => state.CreateTablesUsersReducer);
  const availLicenses = useSelector(selectAvailLicenses);
  const radioSelectedLicense = useSelector(selectModalLicense);
  const license = (selectedUser as any)?.balance?.find(
    (x: any) => x.statusConstantId != LicenseStatus.expired
  ) as ExtendedLicense | undefined;
  const { userRoles } = useSelector(
    (state: State) => state.CreateManagersReducer
  );
  const groups = selectedUser?.rawGroups;
  const memberships = selectedUser?.groupMemberships;
  const checkHandler = (ev: any) => {
    dispatch(focusedLicense(ev.target.value));
  };

  const { locations } = useSelector((state: State) => state.LocationsReducer);
  const locale = useSelector(selectLocale);
  const { actions } = useSelector((state: State) => state.MasterInfoReducer);
  const { user } = useSelector((state: State) => state.Authentication);

  const token = user?.token ?? "";

  const createdAt = moment(selectedUser?.createdAt);
  createdAt.locale(locale);
  const createdAtModify = createdAt.format("l, LT");

  const handleClickShowPassword = async () => {
    if (showPassword) {
      setShowPassword(false);
    } else if (selectedUser) {
      getPassword(token, selectedUser.id);
    }
  };

  // capture unmount lifecycle O_o
  useEffect(() => {
    return () => {
      // clean password when unmounting component
      resetPassword();
    };
  }, []);

  const selectLocalePhoneDefaultInfo = () => {
    switch (locale) {
      case "fr":
        return { code: "FR", label: "France", phone: "33", suggested: true };
      case "en":
        return {
          code: "US",
          label: "United States",
          phone: "1",
          suggested: true,
        };
      case "es":
        return {
          code: "MX",
          label: "Mexico",
          phone: "52",
          suggested: true,
        };
      case "de":
        return {
          code: "DE",
          label: "Germany",
          phone: "49",
          suggested: true,
        };
      default:
        return {
          code: "US",
          label: "United States",
          phone: "1",
          suggested: true,
        };
    }
  };

  const selectLocalePhoneDefaultCode = () => {
    switch (locale) {
      case "fr":
        return "+33";
      case "en":
        return "+1";
      case "es":
        return "+52";
      case "de":
        return "+49";
      default:
        return "+1";
    }
  };

  useEffect(() => {
    fetchRoles(token);
  }, []);

  const availLicencesManagement = () => {
    if (!availLicenses.length) {
      return (
        <div className="access-values-users">
          <div className="option-left">
            <span className="title-view-span">{t("licenses.outOfAvail")}</span>
          </div>
        </div>
      );
    } else {
      return (
        <div className="access-values-users">
          <div className="option-left">
            <RadioGroup onChange={checkHandler}>
              {availLicenses.map((l) => (
                <FormControlLabel
                  label={`${
                    l.availableCredits ||
                    l.packs.find(
                      (p) =>
                        p.statusConstantId == PackStatus.bound ||
                        p.statusConstantId == PackStatus.active
                    )?.initialCredits ||
                    0
                  } ${t("licenses.credits")}`}
                  control={<Radio value={l.id} />}
                  key={l.id}
                />
              ))}
            </RadioGroup>
          </div>
          <div className="option-right">
            <Button
              variant="contained"
              disabled={!radioSelectedLicense}
              onClick={() => {
                dispatch(
                  bindLicenseUser({
                    licenseId: radioSelectedLicense!.id,
                    userGroupId: (selectedUser?.groups as GroupInfoData[]).find(
                      (g) => g.typeId == OrgGroupTypeIds.user
                    )!.id,
                  }) as any
                );
                dispatch(focusedLicense(""));
                selectUser();
                setTimeout(() => window.location.reload(), 100); // yes, we're really doing this
              }}
            >
              {t("Common_options.Add")}
            </Button>
          </div>
        </div>
      );
    }
  };

  // Update user

  const handleLocationChange = (event: SelectChangeEvent) => {
    setUserEditValues({
      ...userValuesUpdate,
      site: event.target.value as string,
    });
  };

  return (
    <Box sx={style2}>
      {!isEditingUser ? (
        <UserActualInformation
          selectedUser={selectedUser}
          createdAtModify={createdAtModify}
          getUserRoleFromGroups={getUserRoleFromGroups}
          memberships={memberships}
          groups={groups}
          userRoles={userRoles}
          locale={locale}
          showPassword={showPassword}
          license={license}
          decipherPassword={decipherPassword}
          loadingUserPassword={loadingUserPassword}
          handleClickShowPassword={handleClickShowPassword}
          unlinkLicenseUser={unlinkLicenseUser}
          selectUser={selectUser}
          availLicencesManagement={availLicencesManagement}
          setShowPassword={setShowPassword}
          setIsEditingUser={setIsEditingUser}
          userValuesUpdate={userValuesUpdate}
          selectLocalePhoneDefaultInfo={selectLocalePhoneDefaultInfo}
          selectLocalePhoneDefaultCode={selectLocalePhoneDefaultCode}
        />
      ) : (
        <UserUpdateInformation
          actions={actions}
          locale={locale}
          isUpdateLoading={isUpdateLoading}
          userValuesUpdate={userValuesUpdate}
          selectedUser={selectedUser}
          isUpdateError={isUpdateError}
          locations={locations}
          handleLocationChange={handleLocationChange}
          updateUser={updateUser}
          setShowPassword={setShowPassword}
          selectUser={selectUser}
          token={token}
          setUserEditValues={setUserEditValues}
        />
      )}
    </Box>
  );
};
